/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetEstimationSuburbanRequest,
  TGetEstimationSuburbanModel,
  IMappers,
  TGetEstimationSuburbanResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IEstimationSuburbanResponse } from '../../entities/estimation_suburban/EstimationSuburbanResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetEstimationSuburbanModel(
  parameters: TGetEstimationSuburbanRequest,
): TGetEstimationSuburbanModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'price-estimator',
    pathApi: '/v1/get-estimation-suburban/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetEstimationSuburbanOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetEstimationSuburbanRequest;
}

export async function fetchGetEstimationSuburban<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetEstimationSuburbanOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetEstimationSuburbanResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetEstimationSuburbanModel(parameters),
    config,
  )) as FetchResponse<TGetEstimationSuburbanResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IEstimationSuburbanResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetEstimationSuburbanResponse>;
}
